/* eslint-disable jsx-a11y/control-has-associated-label */
import { Icon } from '@hologram-dimension/icon';
import { LogDateRangeDropdown, SearchAutoComplete } from 'common-js/components';
import useAppDispatch from 'common-js/hooks/useAppDispatch';
import useAppSelector from 'common-js/hooks/useAppSelector';
import { selectViewFilters } from 'common-js/reducers/drawer/selectors';
import {
  clearAll,
  setDeviceFilter,
  setSearchQuery,
  setViewingAllLogs,
  viewDateRange,
} from 'common-js/reducers/logFilter/actions';
import {
  selectDeviceFilter,
  selectIsViewingAllLogs,
  selectSearchQuery,
  selectSelectedTags,
} from 'common-js/reducers/logFilter/selectors';
import { type FC } from 'react';

const ConsoleFilters: FC = () => {
  const dispatch = useAppDispatch();
  const viewFilters = useAppSelector(selectViewFilters);
  const deviceFilter = useAppSelector(selectDeviceFilter);
  const searchQuery = useAppSelector(selectSearchQuery);
  const isViewingAllLogs = useAppSelector(selectIsViewingAllLogs);
  const selectedTags = useAppSelector(selectSelectedTags);

  const logStartDate = useAppSelector((state) => state.logFilters.allLogFilters.startDate);
  const logEndDate = useAppSelector((state) => state.logFilters.allLogFilters.endDate);

  const topics = useAppSelector((state) => state.topic.allTopics);

  const showFilters = !!(
    viewFilters ||
    selectedTags?.length > 0 ||
    !isViewingAllLogs ||
    searchQuery?.length > 0 ||
    deviceFilter
  );

  const onTopicSearchChange = (newValue, source) => {
    if (source === 'typing') {
      dispatch(setSearchQuery('allLogs', newValue));
    } else {
      dispatch(setSearchQuery('allLogs', newValue, false));
    }
  };

  return (
    <div className="console-filters">
      {showFilters && (
        <div className="filters">
          {deviceFilter && (
            <div className="filter device">
              <div className="filter-name">Device {deviceFilter}</div>
              <div
                className="clear-filter"
                onClick={() => {
                  dispatch(setDeviceFilter(null));
                }}
                onKeyUp={() => {
                  dispatch(setDeviceFilter(null));
                }}
                role="button"
                tabIndex={0}
              >
                <Icon name="Close" />
              </div>
              <div className="arrowhead" />
            </div>
          )}
          <div className="filter dates">
            <LogDateRangeDropdown
              startDate={logStartDate}
              endDate={logEndDate}
              direction="down"
              isViewingAllLogs={isViewingAllLogs}
              onAllLogsSelected={() => {
                dispatch(setViewingAllLogs('allLogs', true));
              }}
              onDateRangeSelected={() => {
                dispatch(setViewingAllLogs('allLogs', false));
              }}
              onDateRangeChange={(startDate, endDate) => {
                dispatch(viewDateRange('allLogs', startDate, endDate));
              }}
              onClear={() => {
                dispatch(clearAll('allLogs'));
              }}
              showApplyButtons={false}
            />
            {!isViewingAllLogs && (
              <div
                className="clear-filter"
                onClick={() => {
                  dispatch(clearAll('allLogs'));
                }}
                onKeyUp={() => {
                  dispatch(clearAll('allLogs'));
                }}
                role="button"
                tabIndex={0}
              >
                <Icon name="Close" />
              </div>
            )}
            <div className="arrowhead" />
          </div>
          <div className="filter last-filter search">
            <SearchAutoComplete
              onChange={onTopicSearchChange}
              showClearButton={false}
              value={searchQuery}
              topics={topics}
            />
            {searchQuery.length > 0 && (
              <div
                className="clear-filter"
                onClick={() => {
                  dispatch(setSearchQuery('allLogs', '', false));
                }}
                onKeyUp={() => {
                  dispatch(setSearchQuery('allLogs', '', false));
                }}
                role="button"
                tabIndex={0}
              >
                <Icon name="Close" />
              </div>
            )}
            <div className="arrowhead" />
          </div>
        </div>
      )}
    </div>
  );
};

export default ConsoleFilters;
